import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';
import './RouvyScraperModal.css';

const RouvyScraperModal = ({ isOpen, onClose, onSuccess, shouldConnect = false, userData = null }) => {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');



  const handleConnect = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axios.post('/api/rouvy/scraper/sync_profile');

      if (response.data.success && response.data.should_redirect && response.data.authorization_url) {
        // Redirect to OAuth authorization
        window.location.href = response.data.authorization_url;
      }
    } catch (err) {
      console.error('Connection error:', err);
      const errorMessage = err.response?.data?.message || err.response?.data?.error || 
        t('rouvy.connectFailed');
      setError(errorMessage);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };



  if (!isOpen) return null;

  // Main connect view
  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content rouvy-scraper-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            {t('rouvy.connectTitle')}
          </h2>
          <button className="modal-close" onClick={handleClose}>×</button>
        </div>

        <div className="modal-body">
          <p className="modal-description">
            {t('rouvy.redirectNotice')}
          </p>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="modal-info">
            <p>
              {t('rouvy.featuresIntro')}
            </p>
            <ul>
              <li>{t('rouvy.featureActivities')}</li>
              <li>{t('rouvy.featureProfile')}</li>
              <li>{t('rouvy.featureAchievements')}</li>
            </ul>
            <p className="modal-info-note">
              <strong>
                {t('rouvy.secureConnection')}
              </strong>
            </p>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              {t('common.cancel')}
            </button>
            <button
              type="button"
              onClick={handleConnect}
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? t('rouvy.connecting') : t('rouvy.connect')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RouvyScraperModal;